import FormattedMessage from 'I18n/components/FormattedMessage';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import { PageSection, SectionContainer, SectionHeader, SectionSubTitle, SectionTitle } from 'pricing-pages-ui-components/semantic/PageSection';
import { COMMERCE } from 'self-service-api/constants/EnrolledProductLines';
import { AllProductLines } from 'self-service-api/constants/ProductLines';
import { useAppSelector } from '../../reducers';
import { isAppAuthSelector } from '../../selectors/AuthSelectors';
import { navItemForProductLineSelector } from '../../selectors/RoutingSelectors';
import { useSSM0009Experiment } from '../../utils/experiments/ssm0009';
import SplashPageCard from './SplashPageCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ProductsSection = ({
  selectedTab,
  sectionProps
}) => {
  const {
    isSSM0009Variant
  } = useSSM0009Experiment();
  const isAppAuth = useAppSelector(isAppAuthSelector);
  const productLines = [...AllProductLines, COMMERCE];
  const productLineTiles = useAppSelector(state => productLines.map(productLine => {
    const navItem = navItemForProductLineSelector(state, productLine);
    const path = isAppAuth || productLine === 'COMMERCE' || isSSM0009Variant ? `/${navItem}` : `/${navItem}/${selectedTab}`;
    return /*#__PURE__*/_jsx(SplashPageCard, {
      titleKey: `splash-page.products.${productLine}.title`,
      descriptionKey: `splash-page.products.${productLine}.description.${selectedTab}`,
      pathname: path,
      showIcon: true,
      productLine: productLine
    }, productLine);
  }));
  return /*#__PURE__*/_jsx(PageSection, Object.assign({}, sectionProps, {
    children: /*#__PURE__*/_jsxs(SectionContainer, {
      paddingBlockStart: (sectionProps === null || sectionProps === void 0 ? void 0 : sectionProps.use) === 'shaded' ? '800' : undefined,
      paddingBlockEnd: (sectionProps === null || sectionProps === void 0 ? void 0 : sectionProps.use) === 'shaded' ? '1300' : undefined,
      children: [/*#__PURE__*/_jsxs(SectionHeader, {
        children: [/*#__PURE__*/_jsx(SectionTitle, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `splash-page.products.title.${selectedTab}`
          })
        }), /*#__PURE__*/_jsx(SectionSubTitle, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `splash-page.products.subtitle.${selectedTab}`
          })
        })]
      }), /*#__PURE__*/_jsx(CardGrid, {
        gap: "800",
        columnSize: 295,
        children: productLineTiles
      })]
    })
  }));
};
export default ProductsSection;